<template>
  <v-sheet
      color="transparent"
      draggable="true"
      v-on:dragstart="start_dragging(doc)"
      v-on:dragend="end_dragging"
      v-on:click="toggle_info"
      class="pa-1" width="33%" style="aspect-ratio: 1 / 0.8;"
      elevation="0"
  >
    <v-sheet style="border-radius: 5px !important;" class="d-flex align-center justify-center not-selected" :color="card_color(doc)" width="100%" height="100%" position="relative" :class="{'selected' : current_doc_in_info}">

      <v-icon class="mr-2" :icon="['fas', 'bolt']" style="color: darkred" v-if="doc.priority === 0" shake />

      <v-chip :class="{'selected-chip' : current_doc_in_info}" variant="flat" style="position: absolute; top: -2px; font-size: 12px" color="white" density="compact" size="small" class="not-selected-chip rounded-b-lg rounded-t-0">
        <p>{{ short_worktype(doc.worktype.name) }} {{ doc.number.replaceAll('0', '') }}</p>
      </v-chip>

      <v-avatar color="white" class="font-weight-bold" size="20" style="font-size: 10px">{{ doc.duration }}</v-avatar>
    </v-sheet>
  </v-sheet>
</template>

<script>
import { CurrentElement, CurrentElement__Data, CurrentElement__Dst } from "@/store/wp_planner/events.store";
import { InfoBlock, MiniInfoBlock } from "@/store/wp_planner/info.store";
import { Del_Documents } from "@/store/wp_planner/documents/deleted.store";
import { Specialists } from "@/store/wp_planner/specialists.store";
import moment from "moment";

export default {
  name: "Document__WP_Card",
  props: ['type', 'doc'],
  data() {
    return {
      show_full: false,
      tooltip: false
    }
  },
  methods: {
    moment,
    card_color: function () {
      return 'grey-lighten-2'
    },
    short_worktype: function (worktype) {
      switch (worktype) {
        case 'Техническое обслуживание':
          return 'ТО'
        case 'Испытания':
          return 'ИСП'
        default:
          return null
      }
    },
    start_dragging: function (event_data) {
      this.event__dst = this.type
      this.event__type = 'document'
      this.event__data = event_data

      console.log(event_data)
    },
    end_dragging: function () {
      event.preventDefault()
      this.event__type = null
      this.event__dst = null
      this.event__data = null
    },
    toggle_info: function() {
      this.info__right = null
      if (this.doc !== this.info) {
        this.info = this.doc
      } else {
        if (this.info === null) {
          this.info = this.doc
        } else {
          this.info = null
        }
      }
    },
    delete_event: function () {
      this.deleted.splice(this.deleted.findIndex(e => e.__ID === this.doc.__ID), 1)
    }
  },
  computed: {
    specialists: {
      get() {
        return Specialists().get()
      },
      set(value) {
        Specialists().set(value)
      }
    },
    p_full() {
      let humans = []
      for (let guid of this.doc.persons) {
        humans.push(this.specialists[this.specialists.findIndex(el=> el.guid === guid)])
      }
      return humans
    },
    current_doc_in_info() {
      if (this.info) {
        if (this.info.__ID) {
          return this.info.guid === this.doc.guid && this.info.__ID === this.doc.__ID
        } else {
          return this.info.guid === this.doc.guid
        }
      } else {
        return false
      }
    },
    has_copies() {
      return this.deleted.filter(el => el.guid === this.doc.guid).length > 1
    },
    deleted: {
      get() {
        return Del_Documents().get()
      },
      set(value) {
        Del_Documents().set(value)
      }
    },
    event__dst: {
      get() {
        return CurrentElement__Dst().get()
      },
      set(value) {
        CurrentElement__Dst().set(value)
      }
    },
    event__data: {
      get() {
        return CurrentElement__Data().get()
      },
      set(value) {
        CurrentElement__Data().set(value)
      }
    },
    event__type: {
      get() {
        return CurrentElement().get()
      },
      set(value) {
        CurrentElement().set(value)
      }
    },
    info: {
      get() {
        return MiniInfoBlock().get()
      },
      set(value) {
        MiniInfoBlock().set(value)
      }
    },
    info__right: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    }
  }
}
</script>

<style>
.transitioner {
  transition: 0.3s;
}
.rotated {
  scale: 1.5;
  rotate: -90deg;
}

.not-selected {
  border: transparent dotted 2px;
  cursor: pointer;
  transition: 0.5s;
}
.selected {
  border: #0c9d18 dotted 2px;
  z-index: 3000;
}
.not-selected-chip {
  border-left: transparent dotted 2px;
  border-right: transparent dotted 2px;
  border-bottom: transparent dotted 2px;
  transition: 0.5s;
}
.selected-chip {
  border-left: #0c9d18 dotted 2px;
  border-right: #0c9d18 dotted 2px;
  border-bottom: #0c9d18 dotted 2px;
  z-index: 3000;
}

#my-tooltip > .v-overlay__content {
  padding: 10px;
  margin: 0;
  backdrop-filter: blur(10px);
  background-color: rgba(172, 172, 172, 0.7);
  border-radius: 10px;
  /*background: linear-gradient(90deg,
    rgba(94,1,1,0.7) 0%,
    rgba(94,1,1,0.7) 30%,
    rgba(46, 3, 3, 0.84) 33%,
    rgba(94,1,1,0.7) 36%,
    rgba(94,1,1,0.7) 100%
  );
  box-shadow: 0 5px 10px 4px rgba(46, 1, 1, 0.5) inset;*/
}
</style>
